import { render, staticRenderFns } from "./dragDrop.vue?vue&type=template&id=a0dc0c52&"
import script from "./dragDrop.vue?vue&type=script&lang=js&"
export * from "./dragDrop.vue?vue&type=script&lang=js&"
import style0 from "./dragDrop.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports